import { Tooltip } from '@mui/material';

import { format } from 'date-fns';

import { Fragment } from 'react';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';
import { nonFalsey } from '@/utils/nonFalsey';

const SIGNER_DESCRIPTION_FRAGMENT = graphql(`
  fragment signerDescriptionFields on File {
    signatures {
      _id
      created
      userCanUnsign
      signedBy {
        _id
        firstName
        lastName
      }
    }
  }
`);

interface Props {
  file: DocumentType<typeof SIGNER_DESCRIPTION_FRAGMENT>;
}

export const SignerDescription = ({ file }: Props) => {
  const signatures = file.signatures?.filter(nonFalsey) || [];

  if (signatures.length === 0) {
    return null;
  }

  const getSignerName = (signature: (typeof signatures)[number]) => {
    const signer = signature.signedBy;
    return `${signer?.firstName} ${signer?.lastName}`;
  };

  const description = signatures.map((signature) => {
    const signerName = getSignerName(signature);
    let val = signerName;
    const { created } = signature;
    if (created) {
      const signerDate = format(new Date(created), 'do MMM yyyy');
      val += ` on ${signerDate}`;
    }

    return (
      <Fragment key={signature._id || ''}>
        {val}
        <br />
      </Fragment>
    );
  });

  return (
    <Tooltip title={description}>
      <span>
        {signatures.length === 1 ? (
          getSignerName(signatures[0])
        ) : (
          <>{String(signatures.length)} people</>
        )}
      </span>
    </Tooltip>
  );
};
